import React, {Component} from 'react';
import RolDropdown from '../../componentes/RolDropdown'
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/functions';
import { Modal, Button, Form, Input, List, Icon} from 'semantic-ui-react'

class Empleado extends Component{

	constructor(props){
		super(props);
		this.useModal = false;
		this.newSueldo = { nombre: "", valor: 0 }
		this.currentUser = props.currentUser
		this.state = {
			id: props.id,
			nombre: props.nombre,
			foto: props.foto,
			correo: (props.correo||"FALTA CORREO"),
			rol: props.rol,
			telefono: (props.telefono||"0"),
			sueldos: props.sueldos,
			activo: (props.activo||"no"),
			uid: props.uid,
			nacimiento: null,
			cambiarRol: false
		}
		if (!props.sueldos) {
			this.state.sueldos = {}
		}
		if (props.nacimiento) {
			this.state.nacimiento = props.nacimiento.toDate().toLocaleDateString()
		}
		this.url = props.url;
		this.sueldos = [
			{ key: "1", text: "Base", value: "Base" },
			{ key: "2", text: "Botero", value: "Botero" },
			{ key: "3", text: "Empaque", value: "Empaque" },
			{ key: "4", text: "Fumigador", value: "Fumigador" },
			{ key: "5", text: "Pisca", value: "Pisca" },
			{ key: "6", text: "PiscaXdia", value: "PiscaXdia" }
		  ]
	}
	activoStatus=()=>{
		if (this.state.activo === "si") {
			return (
			<div>
				<h2>Status: Activo</h2>
				<Button onClick={()=>this.desactivarEmp()}>Desactivar</Button>
			</div>)
		} else if (this.state.activo === "no"){
			const activeLimitReached = this.props.activeEmployeeCount >= this.props.empMax
			return (
			<div>
				<h2>Status: Desactivado</h2>
				<Button disabled={activeLimitReached} onClick={()=>this.activarEmp()}>Activar</Button>
				{activeLimitReached && <p className='employeeLimitNote'>Ya alcanzó el máximo de {this.props.empMax} empleados activos.</p>}
			</div>)
		}
	}
	activarEmp=()=>{
		if (this.state.correo){
			if (this.state.uid){
				this.setState({activo: "si"})
			} else {
				//const uid = SignUP(this.state.mail)
				this.setState({activo: "si"})
			}
		} else {
			alert("Ingresar un correo electrónico")
		}
	}
	desactivarEmp=()=>{
		this.setState({activo: "no"})
	}
	removeSueldo(nombre){
		var newSueldos = this.state.sueldos;
		delete newSueldos[nombre];
		this.setState({sueldos: newSueldos});
	}
	changeUsModal=(e)=>{
		this.setState({useModal:e})
	}
	editarEmpl =(e)=>{
		if (e.target.name === "rol" && e.target.value !== this.state.rol){
			this.setState({cambiarRol: true})
		}
		this.setState({[e.target.name]: e.target.value})
	}
	addSueldo=() => {
		if (this.newSueldo["valor"] > 0 && this.newSueldo["nombre"]){
			var newSueldos = this.state.sueldos
			newSueldos[this.newSueldo["nombre"]] = this.newSueldo["valor"]
			this.setState({ sueldos: newSueldos})
		}
	}
	editarSueldos=(e) => {
		if (e.target.name === "name") {
			this.newSueldo["nombre"] = e.target.value
		} else if (e.target.name === "value"){
			this.newSueldo["valor"] = Number(Number(e.target.value).toFixed(2))
		}
	}
	guardarDatos = async () => {
		try {

			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const isValidemail = emailRegex.test(this.state.correo);
			const functions = firebase.functions()
			const updateName = functions.httpsCallable('assignEmployeeName');
			const addRole = functions.httpsCallable('assignEmployeeRole');
			
			if (this.state.rol && isValidemail){
				if (this.state.cambiarRol){
					await addRole({uid: this.state.uid, rol: this.state.rol})
					await updateName({ uid: this.state.uid, nombre: this.state.nombre })
					this.setState({cambiarRol: false})
				}
				const guardado = await this.props.guardarDatos(this.state)
				if (guardado) {
					this.changeUsModal(false)
				} else {
					this.setState({activo: this.props.activo || 'no'})
				}
			} else {
				console.log(this.state)
				alert("Datos no validos")
			}
		} catch (e) {
		console.log(e)
		alert("Error.")
	}
	} 
	handleRolChange = (event, { value }) => {
		this.setState({rol: value})
	};
	mostrarSueldos =()=>{
		if (Object.keys(this.state.sueldos).length > 0) {
			if (this.currentUser.role === "admin" || this.currentUser.role === "office") {
				return (<td>{JSON.stringify(this.state.sueldos, null, 2)}</td>)
			} else {
				return (<td>{Object.keys(this.state.sueldos).toString()}</td>)
			}
		} else {
			return (
				<td>Agregar Sueldos</td>
			)
		}
	}

	admin =()=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "office" || this.currentUser.email === "admin@admin.com"){
			return(
			<>
			<td><button 
				className='editar'
				onClick={() => this.changeUsModal(true)}><Icon name='edit' />
			</button></td>
			<Modal 
				onClose={() => this.changeUsModal(false)}
				onOpen={() => this.changeUsModal(true)}
				open={this.state.useModal}>
				<Modal.Header>Editar Empleado: {this.state.nombre}</Modal.Header>
				<Modal.Content>
				<Form>
					{this.activoStatus()}
					<Form.Field>
						<label>Correo:</label> 
						<Input 
							type='text' 
							name="correo"
							value={this.state.correo}
							onChange={this.editarEmpl} 
						/>
					</Form.Field>
					<Form.Field>
						<label>Telefono:</label> 
						<Input 
							type='tel' 
							name="telefono"
							value={this.state.telefono}
							onChange={this.editarEmpl} 
						/>
					</Form.Field>
					<Form.Field><label>Rol: </label>	
					<RolDropdown 
						placeholder='Rol Empleados'
						value={this.state.rol} 
						onChange={this.handleRolChange} 
						all={1} 
					/>
					</Form.Field>
					<Form.Field>
						<label>Sueldos:</label>
						<List>
							{
							Object.keys(this.state.sueldos).map((item, i) => (
								<List.Item key={i}>
									<div className='list'>{item}: ${this.state.sueldos[item]} /hora</div>
									<button 
										className='borrar'
										onClick={()=>this.removeSueldo(item)}>
										<Icon name='trash alternate' />
									</button>
								</List.Item>
							))
							}
						</List>
					</Form.Field>
					
						{/*
							<Dropdown 
								compact
								selection
								name="name"
								options={this.sueldos}
								placeholder='Sueldo'
								onChange={this.editarSueldos}
							/>
						*/}
						<div className='contentLeft'>
						<Form.Input 
							type='text' 
							name="name"
							placeholder='Nombre del Puesto'
							onChange={this.editarSueldos} 
							fluid
						/>
						<Input 
							icon='dollar'
							iconPosition='left'
							type='number' 
							name="value"
							placeholder='$ por hora'
							onChange={this.editarSueldos}
							fluid
						/>
						<button className='agregar' 
							onClick={()=>this.addSueldo()}>
							<Icon name='add circle' />
						</button>
					</div>
					
				</Form>
				</Modal.Content>
				<Modal.Actions>
					<button onClick={() => this.guardarDatos()}>Guardar Cambios</button>
				</Modal.Actions>
			</Modal>
			</>
			)
		}
	}

	render(){
		return (
			<>
				{/*<td> <img src={this.url} alt={this.state.id} width="100" height="120"></img> </td>*/}
				<td> {this.state.nombre} </td>
				<td> {this.state.correo} </td>
				<td> {this.state.rol} </td>
				<td> {this.state.activo === 'si' ? 'Sí' : 'No'} </td>
				{this.mostrarSueldos()}
				{this.admin()} 
			</>
		);
	}
}

Empleado.propTypes = {
	actNombre: PropTypes.string
}

export default Empleado;
